module.exports = __webpack_public_path__ + "a9b5e0417974e49f28a465fd9ca61b59.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/couple.jpg
 ** module id = 192
 ** module chunks = 0
 **/